import { render, staticRenderFns } from "./CoozzySyncAltIcon.vue?vue&type=template&id=af63230c&scoped=true"
import script from "./CoozzySyncAltIcon.vue?vue&type=script&lang=js"
export * from "./CoozzySyncAltIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzySyncAltIcon.vue?vue&type=style&index=0&id=af63230c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af63230c",
  null
  
)

export default component.exports